import React, { useState, useEffect } from "react";
import { equals } from "ramda";
import Editor from "../../Editors/TextEditor";
import { noop } from "utils/General";

const TextEditor = ({
  value: initialValue,
  onChange = noop,
  continuous = false,
  disabled = false,
  autocomplete = noop,
  maxLength = null,
  "data-cy": dataCy,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (!equals(initialValue, value)) {
      setValue(initialValue);
    }
  }, [initialValue]);

  const handleBlur = () => onChange(value);
  const handleChange = newValue => {
    setValue(newValue);
    if (continuous) {
      onChange(newValue);
    }
  };

  return (
    <Editor
      maxLength={maxLength}
      disabled={disabled}
      autocomplete={autocomplete}
      onBlur={handleBlur}
      onChange={handleChange}
      value={value}
      className={"styled"}
      data-cy={dataCy}
      {...props}
    />
  );
};

export default TextEditor;
